import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormCheckbox } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import FormEntry from '../../../models/FormEntry'

@observer
class Checkbox extends Component {
  static propTypes = {
    ...FormCheckbox.propTypes,
    formEntry: PropTypes.instanceOf(FormEntry).isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.any,
    errorPointing: PropTypes.oneOf(['below', 'above', 'left']),
    castValue: PropTypes.func, // could be useful if you want to cast a value entered
    parseValue: PropTypes.func // could be useful if you want to parse value to form value
  }

  static defaultProps = {
    defaultValue: false,
    errorPointing: 'above',
    isFixed: false
  }

  handleOnChangeInput = (e, data) => {
    const { formEntry, name, isFixed, onChange } = this.props
    formEntry.updateValue(name, data.checked, isFixed)
    if (onChange) { onChange(data.checked) }
  }

  render () {
    const {
      formEntry,
      defaultValue,
      name,
      options,
      onChange,
      castValue,
      parseValue,
      errorPointing,
      error,
      isFixed,
      ...props
    } = this.props
    let value = formEntry.getValue(name, isFixed, defaultValue) || false // support old version that could be empty string
    if (typeof value === 'string') {
      value = value === name
    }
    return (
      <FormCheckbox
        checked={parseValue ? parseValue(value) : value}
        name={name}
        onChange={this.handleOnChangeInput}
        readOnly={formEntry.readonly}
        {...props}
      />
    )
  }
}
export default Checkbox
